import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { HackerJudgingStatus } from "src/api/types.generated";
import { useEventContext } from "src/shared/contexts";

import { formatDevpostCountdown, getDevpostCountdown } from "../constants";

type Props = {
  status?: HackerJudgingStatus;
};

const COUNTDOWN_SUBTEXT: Record<string, string> = {
  draft: "left to submit your Devpost draft",
  final: "left to submit your final Devpost project",
};

export const DevpostCountdown: React.FC<Props> = ({ status }) => {
  const { judging } = useEventContext();
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const countdown = getDevpostCountdown(
    now,
    status,
    judging.draftDeadline,
    judging.finalDeadline
  );

  if (!countdown) {
    return null;
  }

  const { deadline, mode } = countdown;

  return (
    <CountdownWrapper>
      <TimerText role="timer" aria-live="polite" aria-atomic="true">
        {formatDevpostCountdown(deadline, now)}
      </TimerText>
      <TimerSubtext>{COUNTDOWN_SUBTEXT[mode]}</TimerSubtext>
    </CountdownWrapper>
  );
};

const CountdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 4px;
`;

const TimerText = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.heading};
  font-weight: 900;
  font-size: 28px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  font-feature-settings: "tnum";
  color: ${({ theme }) => theme.globalConstants.color.textBody};
`;

const TimerSubtext = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-weight: 500;
  font-size: 12px;
  line-height: normal;
  color: ${({ theme }) => theme.globalConstants.color.textBody};
`;
